import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { LineDetailsDto } from '../../../data/models/line-details-dto';
import { AccountLineSubjectService } from '../../../services/account-line-subject.service';
import { AccountService } from '../../../services/account.service';
import { MapSubjectService } from '../../../services/map-subject.service';
import { Location } from '@angular/common';
import { DeviceStatusEnum } from '../../../data/enums/device-status-enum';
import { StatusClassService } from '../../../services/status-class.service';
import { LinesPaginationWithCount } from '../../../data/models/lines-pagination-with-count';
@Component({
  selector: 'app-cc-account-lines',
  templateUrl: './cc-account-lines.component.html',
  styleUrls: ['./cc-account-lines.component.scss'],
  providers: [MessageService]
})
export class CcAccountLinesComponent {
  @Input() accountUcid: string;
  @Input() lines: LineDetailsDto[];
  @Output() loadTheMap = new EventEmitter<boolean>();
  @Input() inOutLocation: boolean;
  linesList: LineDetailsDto[];
  lineTotalRecords: number;
  loader: boolean = true;
  pageSize: number = 10;
  selectedLine!: LineDetailsDto;
  filter: string;
  breadItems: MenuItem[];
  constructor(private messageService: MessageService, private accountService: AccountService, private router: Router
    , private mapSubject: MapSubjectService, private accountLineChangesService: AccountLineSubjectService
    , private location: Location, private statusClass: StatusClassService, private activatedRoute: ActivatedRoute) { }

  async ngOnInit() {
    if (!this.accountUcid) {
      //check Url to get account UCID/Id
      this.checkUrlToGetCode();

      this.breadItems =
        [{
          label: 'Home', routerLink: ['/']
        },
        {
          label: 'Account Branches'
        }]
    }   


      this.linesList = this.lines;   
  }

  checkUrlToGetCode() {
    this.activatedRoute.params.subscribe(
      (params) => {
        let accountUcid = params["accountucid"];
        this.accountUcid = accountUcid;
      });
  }

  getViewClass(line) {
    return this.statusClass.getViewClass(line);
  }

 
  /// `Account/lines`,
  loadLines(event) {
    if (event.globalFilter != null || event.globalFilter != undefined) {
      if (event.globalFilter.length<3) 
        return;
    }

    this.loader = true;
    this.pageSize = event.rows;

    let obj = {
      skipped: event.first,
      size: event.rows,
      filter: (event.globalFilter) ? event.globalFilter : null
    }
    this.filter = (event.globalFilter) ? event.globalFilter : null;
    this.accountService.getLinesDetailsOfAccountPagination(obj).subscribe((res: LinesPaginationWithCount) => {
      if (res) {
        this.lineTotalRecords = res.count;
        res.lines.forEach(l => {
          l.fakeName = l.name.split('.')[0] + "." + l.quoteID + " (" + l.popName + ")";
          if (l.pairNum)
            l.fakeName += (".Pair" + l.pairNum);
        });
        this.linesList = res.lines;
        this.loader = false;

        
      }
      else {
        this.linesList = [];
        this.lineTotalRecords = 0;

        this.loader = false;
      }
    }, (error) => {
      this.messageService.add({ severity: 'error', summary: 'Get Lines Details', detail: 'Could not retrieve Lines of this account, please refresh the page' });
      this.loader = false;
    })

  }



  onRowSelect(event) {
    //fire the event that the  rest component are listenning to it ..
    if (this.inOutLocation) {
      const newUrl = '/linedetails/' + this.selectedLine.id;
      this.location.replaceState(newUrl);
      //send HQ and the selected line
      this.accountLineChangesService.notifyChangesInSelectedLineToOther(this.selectedLine)

    }
    else
      //Navigate to LineDetails/lineId
      this.router.navigate(['/linedetails/', this.selectedLine.id]);

    //fire event to map to draw the point of selected line
    let list: LineDetailsDto[] = [];
    list.push(this.selectedLine);
    this.mapSubject.notifyOtherChangesInMap(list);
  }
}
